import React from 'react';
import { iconList } from './iconList';

/**
 * Icon component
 * Syntax to use this component
 * <Icon
		iconName="addSquare"
		iconProps={{ width: '500px', height: '500px', className: 'h-16 w-16' }}
	 />
 * @param {String} iconName
 * @param {Object} iconProps
 * @returns Node
 */
const Icon = ({
  iconName = '',
  iconProps = {},
}: {
  iconName: string;
  iconProps?: object;
}) => {
  const Component = iconList[iconName as keyof typeof iconList];

  return (
    <span>{iconName && Component ? <Component {...iconProps} /> : <></>}</span>
  );
};

export default Icon;
